export enum ApplicationUserTypeId {
  User = 1,
  Client,
  Company,
  OfficialInstitute,
  Membership,
  OrganizedSchool,
  CompanyMembership,
}

export enum ApplicationUserTypeName {
  User = "User",
  Client = "Client",
  Company = "Company",
  Membership = "Membership",
  OrganizedSchool = "OrganizedSchool",
  OfficialInstitute = "OfficialInstitute",
  CompanyMembership = "CompanyMembership",
}
